import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
const _excluded = ["click_action"];
import { getFirebaseServiceWorker } from "@Broker/@Utils/service-workers";
import firebase from "firebase/app";
import Cookie from "js-cookie";
export default {
  methods: {
    getDeviceId() {
      return Cookie.get("fcmDeviceId");
    },
    notificationsBlocked() {
      return this.getNotificationPermissions() === "denied";
    },
    async getToken() {
      if (this.notificationsBlocked()) return null;
      if (!firebase.messaging.isSupported()) return;
      const serviceWorkerRegistration = await getFirebaseServiceWorker();
      const messaging = firebase.messaging();
      const token = await messaging.getToken({
        serviceWorkerRegistration
      });
      return token;
    },
    async listenTokenRefresh(cb = () => {}) {
      if (!firebase.messaging.isSupported()) return;
      if (this.notificationsBlocked()) return null;
      const messaging = firebase.messaging();
      messaging.onTokenRefresh(() => {
        // eslint-disable-next-line no-console
        console.log("Token refresh called"); // TODO: remove when done
        cb();
      });
    },
    listenNotifications(cb = () => {}) {
      //Listen for data/notification in the foreground
      if (!firebase.messaging.isSupported()) return;
      const messaging = firebase.messaging();
      messaging.onMessage(function (payload) {
        const {
          data: rawData,
          notification: rawNotification,
          silent = false
        } = payload.data;
        if (rawData) {
          try {
            const data = JSON.parse(rawData);
            cb(data);
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
          }
        }
        if (!rawNotification || silent !== "false") return;
        try {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const _JSON$parse = JSON.parse(rawNotification),
            {
              click_action
            } = _JSON$parse,
            notification = _objectWithoutProperties(_JSON$parse, _excluded);
          notification.data = {
            click_action
          };
          navigator.serviceWorker.ready.then(registration => {
            if (notification) {
              registration.showNotification(notification.title, notification);
            }
          });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      });

      //Listen for data in background notification
      const firebaseDataChannel = new BroadcastChannel("firebaseDataChannel");
      firebaseDataChannel.onmessage = function ({
        data
      }) {
        cb(data);
      };
    },
    getNotificationPermissions() {
      if (!("Notification" in window)) return "";
      return Notification.permission;
    },
    async requestNotificationPermission() {
      if (!("Notification" in window)) return "";
      return Notification.requestPermission();
    },
    async promptNotificationPermission() {
      if (!("Notification" in window)) return "denied";
      return Notification.requestPermission();
    }
  }
};